const SteelGableMidParts = (nodes, materials, metal, verticalPosition) => {
  let partsToShow = []

  partsToShow.push(
    <group key="steel-gable-mid-parts" >
      <mesh name="HORIZONTAL_MOVE" geometry={nodes.HORIZONTAL_MOVE.geometry} material={materials['Material_0.033']} position={[-0.026, verticalPosition, 0]} >
        {metal}
      </mesh>
      <mesh name="PART_55R508_CROP_SUPPORT_BAR005" geometry={nodes.PART_55R508_CROP_SUPPORT_BAR005.geometry} material={materials['Material_0.033']} position={[-1.5, 0, 0]} >
        {metal}
      </mesh>
    </group>
  )

  return partsToShow
}

export default SteelGableMidParts